import React from "react";
import { withTranslation } from "react-i18next";
import { GroupInput, GroupView, UserGroupInput, UserGroupView, UserView } from "../../../models/general";
import { connect } from "react-redux";
import { AddGroup, AddUsersToGroup, GetGroups, GetUserGroups, RemoveGroup, RemoveUserFromGroup } from "../../../api/General/userGroup";
import { FetchUsers } from '../../../api/General/account';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../../../components/ui/Table';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogBody, DialogFooter, DialogDescription } from '../../../components/ui/Dialog';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';
import AppIcon from '../../../components/AppIcon';
import { Users2 } from 'lucide-react';
import { PageLayout } from '../../../components/ui/PageLayout';

type Props = Readonly<{
    match?: any;
    t: any;
    company?: any;
    userId?: any;
}>;

type State = {
    selectedPageIndex: number;
    count: number;
    offset: number;
    Groups: GroupView[];
    UserGroups: UserGroupView[];
    AddUsers: boolean;
    Users: UserView[];
    userGroupCheckBox: { [key: string]: boolean };
    userCheckBox: { [key: string]: boolean };
    checkedUserGroupIds: string[];
    checkedUserIds: string[];
    selectedGroupId: number;
    AddGroup: boolean;
    GroupName: string;
    DeleteGroup: boolean;
};

class EmployeesGrouping extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            selectedPageIndex: 0,
            count: 10,
            offset: 0,
            Groups: [],
            UserGroups: [],
            AddUsers: false,
            Users: [],
            userGroupCheckBox: {},
            userCheckBox: {},
            checkedUserGroupIds: [],
            checkedUserIds: [],
            selectedGroupId: 0,
            AddGroup: false,
            GroupName: "",
            DeleteGroup: false
        };
    }

    fetch = async () => {
        const groups = await GetGroups()
        this.setState({ Groups: groups.payload }, () => { console.log("Groups", this.state.Groups) })

        const userGroups = await GetUserGroups()
        this.setState({ UserGroups: userGroups.payload })

        const users = await FetchUsers('Company', this.props.company.id, false)
        this.setState({ Users: users.payload })
        this.setState({ checkedUserGroupIds: [], checkedUserIds: [], userGroupCheckBox: {}, userCheckBox: {} })
    }

    AddUserToGroup = async (groupdId: number, userId: string[]) => {
        try {

            console.log("groupId", groupdId)
            console.log("userId", userId)
            const input: UserGroupInput = {
                id: 0,
                groupId: groupdId,
                userId: userId
            }
            const addedUser = await AddUsersToGroup(input)
            this.fetch()
        } catch (ex) {
            console.log(ex)
        }
    }
    RemoveUserFromGroup = async (groupdId: number, userId: string[]) => {
        try {
            console.log("groupId", groupdId)
            console.log("userId", userId)
            const input: UserGroupInput = {
                id: 0,
                groupId: groupdId,
                userId: userId
            }
            const removedUser = await RemoveUserFromGroup(input)
            this.fetch()
        } catch (ex) {
            console.log(ex)
        }
    }
    AddGroup = async () => {
        try {
            const input: GroupInput = {
                id: 0,
                name: this.state.GroupName
            }
            const addGroup = await AddGroup(input)
            this.setState({ AddGroup: false })
            this.fetch()
        } catch (ex) {
            console.log(ex)
        }
    }
    RemoveGroup = async (id: number) => {
        try {
            console.log(id)
            const removeGroup = await RemoveGroup(id)
            this.setState({ DeleteGroup: false })
            this.fetch()
        } catch (ex) {
            console.log(ex)
        }
    }

    onCheck = (e: any, checked: boolean, userId: string, tableType: 'userGroup' | 'user') => {
        this.setState(prevState => {
            const updatedState = { ...prevState };
            if (tableType === 'userGroup') {
                updatedState.userGroupCheckBox[userId] = checked;
                if (checked) {
                    updatedState.checkedUserGroupIds = [...prevState.checkedUserGroupIds, userId];
                } else {
                    updatedState.checkedUserGroupIds = prevState.checkedUserGroupIds.filter(id => id !== userId);
                }
            } else {
                updatedState.userCheckBox[userId] = checked;
                if (checked) {
                    updatedState.checkedUserIds = [...prevState.checkedUserIds, userId];
                } else {
                    updatedState.checkedUserIds = prevState.checkedUserIds.filter(id => id !== userId);
                }
            }
            return updatedState;
        });
    };

    componentDidMount() {
        this.fetch()
    }

    render() {
        const { t } = this.props;

        return (
            <PageLayout
                title={t("Employee Grouping")}
                description={t("Organize employees into groups")}
                icon={Users2}
                accentColor="amber"
                maxWidth="1600px"
                headerActions={
                    <Button
                        variant="outline"
                        iconName="Plus"
                        iconPosition="right"
                        className="w-[210px]"
                        onClick={() => { this.setState({ AddGroup: true }) }}
                    >
                        {t("Add Group")}
                    </Button>
                }
            >
                <Dialog open={this.state.AddGroup} onOpenChange={(open) => this.setState({ AddGroup: open })}>
                    <DialogContent size="sm" aria-describedby={undefined}>
                        <DialogHeader><DialogTitle>{t("Add New Group")}</DialogTitle></DialogHeader>
                        <DialogBody>
                            <div className="flex flex-col gap-5 pt-5">
                                <Input
                                    autoFocus
                                    label={t("Name")}
                                    onChange={(ev: React.ChangeEvent<HTMLInputElement>) => {
                                        this.setState({ GroupName: (ev.target as HTMLInputElement).value });
                                    }}
                                />
                            </div>
                        </DialogBody>
                        <DialogFooter>
                            <Button variant="outline" onClick={() => { this.setState({ AddGroup: false }) }}>{t("Cancel")}</Button>
                            <Button variant="default" onClick={this.AddGroup}>{t("Add")}</Button>
                        </DialogFooter>
                    </DialogContent>
                </Dialog>
                <Dialog open={this.state.DeleteGroup} onOpenChange={(open) => this.setState({ DeleteGroup: open })}>
                    <DialogContent size="sm">
                        <DialogHeader><DialogTitle>{t("Delete Group")}</DialogTitle></DialogHeader>
                        <DialogBody>
                            <DialogDescription>{t("Are you sure you want to delete this group?")}</DialogDescription>
                        </DialogBody>
                        <DialogFooter>
                            <Button variant="outline" onClick={() => { this.setState({ DeleteGroup: false }) }}>{t("Cancel")}</Button>
                            <Button variant="destructive" onClick={() => { this.RemoveGroup(this.state.selectedGroupId) }}>{t("Delete")}</Button>
                        </DialogFooter>
                    </DialogContent>
                </Dialog>
                {this.state.Groups.map((row) => (
                    <details key={row.id} className="group border border-border rounded-lg">
                        <summary className="flex items-center justify-between p-4 cursor-pointer list-none" onClick={() => { this.setState({ selectedGroupId: row.id }) }}>
                            <span className="text-base font-semibold text-primary">{row.name}</span>
                            <AppIcon name="ChevronDown" className="transition-transform group-open:rotate-180" size={20} />
                        </summary>
                        <div className="p-4 border-t border-border">
                            {!this.state.AddUsers ? (
                                <div className="flex justify-end items-end">
                                    <Button variant="ghost" iconName="Pencil" onClick={() => { this.setState({ AddUsers: true }) }}>{t("Edit Group")}</Button>
                                    <Button variant="ghost" iconName="Trash2" onClick={() => { this.setState({ DeleteGroup: true }) }}>{t("Remove Group")}</Button>
                                </div>
                            ) : (
                                <div className="flex justify-end items-end">
                                    <Button variant="ghost" iconName="Check" onClick={() => { this.setState({ AddUsers: false }) }}>{t("Done")}</Button>
                                </div>
                            )}
                            {!this.state.AddUsers ? (
                                <div className="border border-border rounded-lg">
                                    <Table className="table-standard table-outline-rows table-compact">
                                        <TableHeader>
                                            <TableRow>
                                                <TableHead>{t("common:Employee")}</TableHead>
                                                <TableHead>{t("Position")}</TableHead>
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody>
                                            {this.state.UserGroups.filter((user) => row.id === user.group.id).map((user) => (
                                                <TableRow key={user.user.fullName}>
                                                    <TableCell>
                                                        {user.user.fullName}
                                                    </TableCell>
                                                    <TableCell>{user.user.title}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </div>
                            ) : (
                                <div className="flex gap-5">
                                    <div className="border border-border rounded-lg">
                                        <Table className="table-standard table-outline-rows table-compact">
                                            <TableHeader>
                                                <TableRow>
                                                    <TableHead></TableHead>
                                                    <TableHead>{t("common:Employee")}</TableHead>
                                                    <TableHead>{t("Position")}</TableHead>
                                                </TableRow>
                                            </TableHeader>
                                            <TableBody>
                                                {this.state.UserGroups.filter((user) => row.id === user.group.id).map((user) => (
                                                    <TableRow key={user.user.fullName}>
                                                        <TableCell>
                                                            <Checkbox
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.onCheck(e, (e.target as HTMLInputElement).checked, user.user.id, 'userGroup')}
                                                                checked={this.state.userGroupCheckBox[user.user.id] || false}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            {user.user.fullName}
                                                        </TableCell>
                                                        <TableCell>{user.user.title}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                    <div className="flex flex-col pt-24">
                                        <Button variant="ghost" size="icon" onClick={() => this.AddUserToGroup(this.state.selectedGroupId, this.state.checkedUserIds)}>
                                            <AppIcon name="ArrowLeft" size={32} className="text-primary" />
                                        </Button>
                                        <Button variant="ghost" size="icon" onClick={() => this.RemoveUserFromGroup(this.state.selectedGroupId, this.state.checkedUserGroupIds)}>
                                            <AppIcon name="ArrowRight" size={32} className="text-primary" />
                                        </Button>
                                    </div>
                                    <div className="border border-border rounded-lg">
                                        <Table className="table-standard table-outline-rows table-compact">
                                            <TableHeader>
                                                <TableRow>
                                                    <TableHead></TableHead>
                                                    <TableHead>{t("common:Employee")}</TableHead>
                                                    <TableHead>{t("Position")}</TableHead>
                                                </TableRow>
                                            </TableHeader>
                                            <TableBody>
                                                {this.state.Users.map((user) => (
                                                    <TableRow key={user.fullName}>
                                                        <TableCell>
                                                            <Checkbox
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.onCheck(e, (e.target as HTMLInputElement).checked, user.id, 'user')}
                                                                checked={this.state.userCheckBox[user.id] || false}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            {user.fullName}
                                                        </TableCell>
                                                        <TableCell>{user.title}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                </div>
                            )}
                        </div>
                    </details>
                ))}
            </PageLayout>
        );
    }
}
const mapStateToProps = (state: any) => {
    return {
        userId: state.user.userId,
        company: state.user.company
    };
}

export default connect(mapStateToProps)(withTranslation()(EmployeesGrouping as any) as any);
